import { useRecoilState } from "recoil";
import shopState from "../../../../../recoil/atoms/current-shop";
import userState from "../../../../../recoil/atoms/auth/user";
import { Button } from "reactstrap";
import { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";

const ClientTypeSelection = ({ externalKey, step, goNextStep, booking, setBooking }) => {
  const [shop] = useRecoilState(shopState);
  const [user, setUser] = useRecoilState(userState);
  const [proceed, setProceed] = useState(false);

  useEffect(() => {
    if (proceed && shop?.feature_settings) {
      goNextStep();
    }
  }, [proceed, shop]);

  useEffect(() => {
    if (user) {
      setBooking({
        ...booking,
        returningClientFlow: true,
      });
      setProceed(true);
    }
  }, []);

  useEffect(() => {
    if (booking?.returningClientFlow || user) {
      setProceed(true);
    }
  }, [booking?.returningClientFlow]);

  const onSelectClientType = (clientType) => {
    if (clientType === "new") {
      setBooking({
        ...booking,
        returningClientFlow: false,
      });
      setProceed(true);
    } else if (clientType === "returning") {
      setBooking({
        ...booking,
        returningClientFlow: true,
      });
    }
  };

  useEffect(() => { // If a redirect is set, jump to returning client login
    const redirect = new URLSearchParams(window.location.search).get("redirect");
    if (redirect) {
      setBooking({
        ...booking,
        returningClientFlow: true,
      });
    }
  }, [shop]);

  return (
    <div className="client-type-selection">
      {!!shop && (
        <div className="header">
          <span
            className="header-title"
          >
            Hello! 👋 Have you visited
          </span>
          <span
            className="header-title"
          >
            {shop?.name} before?
          </span>
          <div className="buttons-container">
          <Button
            className="button"
            color="primary"
            outline
            onClick={() => {
              onSelectClientType("new");
            }}
          >
            New client
          </Button>
          <Button
            className="button"
            color="primary"
            onClick={() => {
              onSelectClientType("returning");
            }}
          >
            Returning client
          </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ClientTypeSelection;
